import './styles.scss';
import './../node_modules/@fortawesome/fontawesome-svg-core/styles.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
